<template>
    <section class="favorites">
        <section class="subpage-header">
            <ModuleSubpageMenu :module="menuItems" v-if="menuItems"></ModuleSubpageMenu>

            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="subpage__header">
                            <figure>
                                <IconFavoriteBig></IconFavoriteBig>
                            </figure>
                            <h2 class="subpage__title">Ulubione</h2> 
                        </div>
                    </div>    
                </div>
            </div>
        </section>

        <div class="container" data-aos="fade-in" data-aos-delay="200">
            <template v-if="activeSubProfile">
                <div class="columns is-multiline" v-if="favorites && favorites.total_count">
                    <div class="column is-4-desktop is-6-tablet is-12-mobile" v-for="item in favorites.items" :key="item._id">
                        <transition-group name="list" appear>
                            <MbBox :item="item" :isFavorite="checkIsFavorite(item._id)" :key="item._id" :selectedSubProfile="selectedSubProfile"></MbBox>
                        </transition-group>
                    </div>
                </div>
                <div v-else>
                    <span class="favorites__empty">Brak elementów dodanych do listy ulubionych</span>
                </div>
            </template>

            <template v-else>
                <div class="favorites__subprofiles">
                    <button 
                        v-for="item in subProfilesList"
                        class="favorites__subprofiles-item"  
                        :class="{'active': selectedSubProfile === item._id }"
                        :key="item._id"
                        @click="setActiveSubProfile(item._id)"
                    >
                        {{ item.name }}
                    </button>
                </div>

                <div class="columns is-multiline" v-if="favorites && favorites.total_count" data-aos="fade-in">
                    <div class="column is-4-desktop is-6-tablet is-12-mobile" v-for="item in favorites.items" :key="item._id">
                        <transition-group name="list" appear>
                            <MbBox 
                                :item="item" 
                                :key="item._id" 
                                :selectedSubProfile="selectedSubProfile"
                                :isFavorite="checkIsFavorite(item._id)"
                            ></MbBox>
                        </transition-group>
                    </div>
                </div>
                <div v-else>
                    <span class="favorites__empty">Brak elementów dodanych do listy ulubionych</span>
                </div>
            </template>

            <Pagination 
                v-if="isPagination"
                :type="pageType"
                :name="name"
                :id="pageId"
                :itemsPage="itemsPage"
                :itemsPerPage="itemsPerPage" 
                :itemsTotalCount="totalCount">
            </Pagination>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import Pagination from "../elements/Pagination.vue";
import IconFavoriteBig from "../elements/icons/IconFavoriteBig.vue";
import ModuleSubpageMenu from "../modules/ModuleSubpageMenu.vue";
import MbBox from "../boxes/MbBox.vue";

export default {
    name: "Favorites",
    components: {
        MbBox,
        ModuleSubpageMenu,
        IconFavoriteBig,
        Pagination
    },
    data() {
        return {
            itemsPerPage: 12,
            selectedSubProfile: '',
            MENU: '/api/krainaabc/partial/menu?device=www',
            menuItems: []
        };
    },
    watch: {
        // jeśli zmieniono zakładkę z subprofilem pobierz ulubione tego subprofilu
        selectedSubProfile(newValue) {
            if(newValue && !this.activeSubProfile) {
                this.$store.dispatch("favorites", { id: this.selectedSubProfile, itemsPerPage: this.itemsPerPage, itemsPage: this.itemsPage });
            }
        },
        // jeśli zmieniono aktywny subprofil na 'Rodzic' pobierz ulubione dla pierwszego subprofilu z listy
        activeSubProfile(newValue) { 
            if(newValue) {
                this.$store.dispatch("favorites", { id: this.activeSubProfile._id, itemsPerPage: this.itemsPerPage, itemsPage: this.itemsPage });
                this.selectedSubProfile = '';
            } else {
                if(this.subProfilesList && this.subProfilesList[0] && this.subProfilesList[0]._id) {
                    this.selectedSubProfile = this.subProfilesList[0]._id;
                }

                this.$store.dispatch("favorites", { id: this.selectedSubProfile, itemsPerPage: this.itemsPerPage, itemsPage: this.itemsPage });
            }
        },
        subProfilesList() {
            if(!this.activeSubProfile && this.subProfilesList && this.subProfilesList[0] && this.subProfilesList[0]._id) {
                this.selectedSubProfile = this.subProfilesList[0]._id;
            }
        },
        '$route.path': {
            handler: function() {
                if(this.activeSubProfile) {
                    this.$store.dispatch("favorites", { id: this.activeSubProfile._id, itemsPerPage: this.itemsPerPage, itemsPage: this.itemsPage });
                    this.selectedSubProfile = '';
                } else {
                    if(this.subProfilesList && this.subProfilesList[0] && this.subProfilesList[0]._id) {
                        this.selectedSubProfile = this.subProfilesList[0]._id;
                    }

                    this.$store.dispatch("favorites", { id: this.selectedSubProfile, itemsPerPage: this.itemsPerPage, itemsPage: this.itemsPage });
                }
            },
            deep: true,
            immediate: true
        }        
    },
    computed: {
        itemsPage() {
            if(this.$route.query.page) {
                return parseInt(this.$route.query.page);
            }
            return 1;
        },
        totalCount() {
            if(this.favorites && this.favorites.total_count) {
                return this.favorites.total_count;
            }
            return false;
        },
        isPagination() {
            if(this.totalCount && this.totalCount > this.itemsPerPage) {
                return true;
            } 
            return false;
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        subProfilesList() {
            return this.$store.getters.getSubProfiles;
        },
        favorites() {
            return this.$store.getters.getFavorites;
        },
        name() {
            if(this.$route && this.$route.name) {
                return this.$route.name
            }
            return null;
        },
        pageType() {
            if(this.type) {
                return this.type;
            }
            else if(this.$route.params.type) {
                return this.$route.params.type;
            } else {
                return window.__pageSettings.type;
            }
        },
        pageId() {
            if(this.$route.params.id) {
                return parseInt(this.$route.params.id);
            } else {
                return window.__pageSettings.id;
            }
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        setActiveSubProfile(id) {
            this.selectedSubProfile = id;
        },
        checkIsFavorite(id) {
            if(this.favorites && this.favorites.items && this.favorites.items.length && this.favorites.items.findIndex(el => el._id === id) !== -1) {
                return true;
            }
            return false;
        },
        getMenu() {
            axios
                .get(this.MENU)
                .then((response) => { 
                    if(response.data && response.data.data) {
                        this.menuItems = response.data.data;
                    }
                })         
        }
    },
    mounted() {
        // if(!this.activeSubProfile && this.subProfilesList && this.subProfilesList[0] && this.subProfilesList[0]._id) {
        //     this.selectedSubProfile = this.subProfilesList[0]._id;
        // }
        this.getMenu();

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        ); 
    }
}
</script>
